// src/pages/micuenta/MiCuenta.jsx
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import MiCuentaEmpleadorMenu from "./MiCuentaEmpleadorMenu";
import MiCuentaUsuarioMenu from "./MiCuentaUsuarioMenu";
import "./micuentausuarioempleador.css";

function MiCuenta() {
  const { user } = useContext(AuthContext);

  if (!user) {
    return <div className="account-container">Cargando datos del usuario...</div>;
  }

  // Usamos el rol que viene del usuario (suponiendo que en el objeto user esté en la propiedad "userType")
  const userType = user.userType.toLowerCase();

  return (
    <div className="account-container">
      <div className="account-card">
        {userType === "employer" ? (
          <MiCuentaEmpleadorMenu />
        ) : (
          <MiCuentaUsuarioMenu />
        )}
      </div>
    </div>
  );
}

export default MiCuenta;